import carouselConfig from '../../config/carousel.config';
import './ButtonStyleSelector.css';

/**
 * ButtonStyleSelector Component
 * Dropdown selector for carousel button styles with visual preview
 *
 * Props:
 * - value: string - Currently selected button style value
 * - onChange: (value) => void - Called when selection changes
 * - error: string - Error message to display
 * - disabled: boolean - Disable the selector
 */
function ButtonStyleSelector({ value, onChange, error, disabled = false }) {
  const { buttonStyles } = carouselConfig;

  const handleChange = (e) => {
    const newValue = e.target.value || null;
    onChange(newValue);
  };

  return (
    <div className="button-style-selector">
      <label className="form-label" htmlFor="buttonStyle">
        Button Style
      </label>

      <select
        id="buttonStyle"
        className={`form-select ${error ? 'is-invalid' : ''}`}
        value={value || ''}
        onChange={handleChange}
        disabled={disabled}
      >
        <option value="">Select a style...</option>
        {buttonStyles.map((style) => (
          <option key={style.value} value={style.value}>
            {style.label}
          </option>
        ))}
      </select>

      {error && <div className="invalid-feedback">{error}</div>}

      {/* Style Preview */}
      {value && (
        <div className="button-style-preview">
          <span className="preview-label">Preview:</span>
          <div className="preview-container">
            <span className={`preview-button preview-button--${value}`}>
              BUTTON TEXT
            </span>
          </div>
          <span className="preview-description">
            {buttonStyles.find((s) => s.value === value)?.description}
          </span>
        </div>
      )}
    </div>
  );
}

export default ButtonStyleSelector;
